/** Photo interface */
export interface IPhoto {
  /**
   * Photo id (if saved to DB)
   * @deprecated
   */
  id?: number;
  /** Photo Defect Id */
  defectId: number;
  /** Photo filename on device */
  filename: string;
  /** Photo base64 string - optional */
  base64Photo?: string;
  /** Photo safe view URL - optional */
  safeViewUrl?: string;
  /** Photo safe view URL - optional */
  safeViewUrlThumb?: string;
  /** Photo id (if saved to Cloud DB) */
  cloudId: number;
  /** For UI handling when images don't load */
  imageErrorCount: number;
}

export enum ImageType {
  PHOTO = "photo",
  LOGO = "logo",
  PROJECT = "project",
}
